export const BASE_URL = "/";

export const ROLE_ROUTES = {
  "SUPERADMIN": "/superAdmin",
  'GS ADMIN': '/GACSAdmin',
  "TRANSLATOR ADMIN": "/translatorAdmin",
  "VALIDATOR ADMIN": "/validatorAdmin",
  VALIDATOR_ADMIN: "/validatorAdmin",
  // ADMIN: "/admin",
  "VALIDATOR": '/validator',
  "TRANSLATOR USER": "/translator",
  "VALIDATOR USER": "/validator",
  "DEVANAGARI ADMIN": "/devnagriValidatorAdmin",
  "DEVANAGARI USER": "/devnagriValidator",
  "STUDENT": "/student",
  "REVIEWER": "/reviewer",
  DEFAULT: "/",
};

// utils/constants.js
export const restrictSpecialCharacters = (value) => {
  return value.replace(/[^a-zA-Z0-9\s,()?]/g, ""); 
};

export const restrictSpecialCharactersMultilingual = (value) => {
  // Allow: Letters, Numbers, Punctuation, Symbols, Separators (spaces), Marks
  return value.replace(/[^\p{L}\p{N}\p{P}\p{S}\p{Z}\p{M}\p{Mc}\p{Mn}\p{Me}]/gu, "");
};



export const GAADMIN_ID = 2;
export const DEVNAGRI_ID = 3;

export const securityQuestions = {
  1: "What is your first school name?",
  2: "What is your mother maiden name?",
  3: "What is your first pet name?",
  4: "What is your birth city name?"
};

export const salutations = {
  1: "Mr",
  2: "Ms",
  3: "Mrs",
  4: "Dr",
  5: "Prof"
};

export const gender = {
  1: "Male",
  2: "Female",
};

export const validRoles = {
  3: "Translator Admin",
  4: "Validator Admin",
  5: "DEVANAGARI ADMIN",
  6: "Translator User",
  7: "Validator User",
  8: "DEVANAGARI USER"
};


export const LANGUAGE_CODES = {
  HINDI: "1",
  MARATHI: "2",
  // Add more as needed
};

export const formatFileSize = (size) => {
  if (!size) return "0 B";
  if (size < 1024) return `${size} B`;
  if (size < 1024 * 1024) return `${(size / 1024).toFixed(2)} KB`;
  return `${(size / (1024 * 1024)).toFixed(2)} MB`;
};


export const languageIdToName = {
  1: "Hindi",
  2: "English",
  3: "Bengali",
  4: "Marathi",
  5: "Telugu",
  6: "Tamil",
  7: "Urdu",
  8: "Gujarati",
  9: "Kannada",
  10: "Odia",
  11: "Punjabi",
  12: "Malayalam",
  13: "Assamese",
  14: "Maithili",
  15: "Santali",
  16: "Kashmiri",
  17: "Nepali",
  18: "Sindhi",
  19: "Dogri",
  20: "Konkani",
  21: "Bodo",
  22: "Sanskrit",
  23: "Manipuri"
};


export const getStatusStyle = (status) => {
  const styles = {
    PENDING: { bg: "bg-yellow-100", text: "text-yellow-800", label: "Pending" },
    ASSIGNED: { bg: "bg-yellow-100", text: "text-yellow-800", label: "Assigned" },
    GS_ASSIGNED: { bg: "bg-blue-100", text: "text-blue-800", label: "GS Assigned" },
    DEV_ASSIGNED: { bg: "bg-purple-100", text: "text-purple-800", label: "Dev Assigned" },
    TA_ASSIGNED: { bg: "bg-indigo-100", text: "text-indigo-800", label: "TA Assigned" },
    VA_ASSIGNED: { bg: "bg-pink-100", text: "text-pink-800", label: "VA Assigned" },
    DU_ASSIGNED: { bg: "bg-cyan-100", text: "text-cyan-800", label: "DU Assigned" },
    UNDER_TRANSLATION: { bg: "bg-orange-100", text: "text-orange-800", label: "Under Translation" },
    UNDER_VALIDATION: { bg: "bg-lime-100", text: "text-lime-800", label: "Under Validation" },
    DEV_VALIDATED: { bg: "bg-emerald-100", text: "text-emerald-800", label: "Dev Validated" },
    TRANSLATED: { bg: "bg-teal-100", text: "text-teal-800", label: "Translated" },
    VALIDATED: { bg: "bg-sky-100", text: "text-sky-800", label: "Validated" },
    GS_REJECTED: { bg: "bg-rose-100", text: "text-rose-800", label: "GS Rejected" },
    DEV_REJECTED: { bg: "bg-red-100", text: "text-red-800", label: "Dev Rejected" },
    REJECTED: { bg: "bg-red-100", text: "text-red-800", label: "Rejected" },
    COMPLETED: { bg: "bg-green-100", text: "text-green-800", label: "Completed" },
    SUBMITTED_TO_CDAC: { bg: "bg-green-100", text: "text-green-800", label: "Submitted to CDAC" },
    SENT_TO_VA: { bg: "bg-green-100", text: "text-green-800", label: "Sent to Validator Admin" },
  };

  return styles[status] || { bg: "bg-gray-100", text: "text-gray-800", label: status };
};



export const getStatusStyleGA = (status) => {
  const styles = {
    PENDING: { bg: "bg-yellow-100", text: "text-yellow-800", label: "Pending" },
    ASSIGNED: { bg: "bg-blue-100", text: "text-blue-800", label: "Assigned" },
    GS_ASSIGNED: { bg: "bg-blue-100", text: "text-blue-800", label: "GS Assigned" },
    DEV_ASSIGNED: { bg: "bg-purple-100", text: "text-purple-800", label: "Dev Assigned" },
    TA_ASSIGNED: { bg: "bg-indigo-100", text: "text-indigo-800", label: "TA Assigned" },
    VA_ASSIGNED: { bg: "bg-pink-100", text: "text-pink-800", label: "VA Assigned" },
    DU_ASSIGNED: { bg: "bg-cyan-100", text: "text-cyan-800", label: "DU Assigned" },
    UNDER_TRANSLATION: { bg: "bg-orange-100", text: "text-orange-800", label: "Under Translation" },
    UNDER_VALIDATION: { bg: "bg-lime-100", text: "text-lime-800", label: "Under Validation" },
    DEV_VALIDATED: { bg: "bg-emerald-100", text: "text-emerald-800", label: "Dev Validated" },
    TRANSLATED: { bg: "bg-teal-100", text: "text-teal-800", label: "Translated" },
    VALIDATED: { bg: "bg-sky-100", text: "text-sky-800", label: "Validated" },
    GS_REJECTED: { bg: "bg-rose-100", text: "text-rose-800", label: "GS Rejected" },
    DEV_REJECTED: { bg: "bg-red-100", text: "text-red-800", label: "Dev Rejected" },
    REJECTED: { bg: "bg-red-100", text: "text-red-800", label: "Rejected" },
    COMPLETED: { bg: "bg-green-100", text: "text-green-800", label: "Completed" },
    SUBMITTED_TO_CDAC: { bg: "bg-green-100", text: "text-green-800", label: "Submitted to CDAC" },
    SENT_TO_VA: { bg: "bg-green-100", text: "text-green-800", label: "Completed" },
  };

  return styles[status] || { bg: "bg-gray-100", text: "text-gray-800", label: status };
};